/**
 * Uploads a file to a presigned URL (Cloudflare R2)
 * Uses fetch on both web and native platforms to send raw binary data
 * @param file - The file to upload
 * @param presignedUrl - The presigned URL from the backend
 * @returns Promise that resolves when upload is complete
 */
export async function uploadFileToPresignedUrl(
  file: File,
  presignedUrl: string
): Promise<void> {
  try {
    // Use fetch on both platforms - it works on native and sends raw binary correctly
    // Presigned URLs (S3/R2) require raw binary data, not base64
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      throw new Error(`Upload failed with status ${response.status}: ${errorText}`);
    }
  } catch (error) {
    console.error('Error uploading file to presigned URL:', error);
    throw error;
  }
}

